import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from '../utils/IconWrapper';
import RegistrationWizard from '../components/auth/registration-wizard';
import EmailConfirmationModal from '../components/ui/EmailConfirmationModal';

const PageContainer = styled.div`
  min-height: 100vh;
  background-color: var(--bg-primary);
  padding: 2rem 1rem;
`;

const Container = styled.div`
  max-width: 1000px;
  margin: 0 auto;
`;

const BackLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: #0d9488;
  text-decoration: none;
  font-weight: 500;
  margin-bottom: 2rem;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(13, 148, 136, 0.1);
    transform: translateX(-4px);
  }
`;

const BenefitsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
  margin: 2rem 0;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const BenefitCard = styled.div`
  background: var(--bg-secondary);
  border-radius: 12px;
  padding: 1.5rem;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  border: 2px solid var(--border-color);
  transition: all 0.2s ease;
  
  &:hover {
    border-color: #0d9488;
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(13, 148, 136, 0.15);
  }
`;

const BenefitIcon = styled.div`
  font-size: 2.5rem;
  margin-bottom: 1rem;
`;

const BenefitTitle = styled.h3`
  color: #0d9488;
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
`;

const BenefitDescription = styled.p`
  color: var(--text-secondary);
  font-size: 0.9rem;
  line-height: 1.5;
`;

const Register: React.FC = () => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [completedData, setCompletedData] = useState<any>(null);
  const navigate = useNavigate();

  const handleRegistrationComplete = (data: any) => {
    setCompletedData(data);
    setShowSuccess(true);
    
    // Redirect to dashboard after 3 seconds
    setTimeout(() => {
      navigate('/dashboard');
    }, 3000);
  };

  const handleSuccessClose = () => {
    setShowSuccess(false);
    navigate('/dashboard');
  };

  const benefits = [
    {
      icon: '✨',
      title: 'Sconti Esclusivi',
      description: 'Fino al 20% di sconto sui nostri alloggi più richiesti'
    },
    {
      icon: '🏠',
      title: 'Accesso Prioritario',
      description: 'Prenota per primo le nostre nuove proprietà premium'
    },
    {
      icon: '📧',
      title: 'Offerte Personalizzate',
      description: 'Ricevi offerte su misura per le tue preferenze di viaggio'
    }
  ];

  return (
    <PageContainer>
      <Container>
        <BackLink to="/">
                      <ArrowLeftIcon />
            Torna alla home
        </BackLink>



        <BenefitsGrid>
          {benefits.map((benefit, index) => (
            <BenefitCard key={index}>
              <BenefitIcon>{benefit.icon}</BenefitIcon>
              <BenefitTitle>{benefit.title}</BenefitTitle>
              <BenefitDescription>{benefit.description}</BenefitDescription>
            </BenefitCard>
          ))}
        </BenefitsGrid>



        <RegistrationWizard
          onComplete={handleRegistrationComplete}
          onCancel={() => navigate('/')}
        />

        {/* Email Confirmation Modal */}
        {showSuccess && (
          <EmailConfirmationModal
            userEmail={completedData?.email}
            onClose={handleSuccessClose}
            onResendEmail={() => {
              // Qui potresti implementare la logica per rinviare l'email
              console.log('Richiesta rinvio email per:', completedData?.email);
            }}
          />
        )}
      </Container>
    </PageContainer>
  );
};

export default Register; 